export default __webpack_public_path__ + "static/media/down-arrow-white.86150370.svg";